module.exports = __webpack_public_path__ + "img/instagram-reels.237732bc.webp";